<app-auth-layout>
  <app-h3>Update Password</app-h3>
  
  <form *ngIf="stateService.formGroup$ | async as formGroup" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-md-12 mb-3">
        <app-password-input
          tid="new-password"
          formPropertyName="password"
          label="New Password"
          type="password"
          placeholder="Enter your new password"
          [minLength]="12"
          [requiredField]="true"
        ></app-password-input>
        <mat-error
          *ngIf="
            formGroup.get('password')?.errors?.['invalidPassword'] &&
            formGroup.get('password')?.touched &&
            formGroup.get('password')?.dirty
          "
        >
          Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character
        </mat-error>
      </div>

      <div class="col-md-12 mb-3">
        <app-password-input
          tid="confirm-password"
          formPropertyName="passwordConfirmation"
          label="Confirm Password"
          type="password"
          placeholder="Confirm your new password"
          [requiredField]="true"
          [minLength]="12"
        ></app-password-input>
        <mat-error
          *ngIf="
            formGroup.get('passwordConfirmation')?.errors?.['notMatching'] &&
            formGroup.get('passwordConfirmation')?.touched &&
            formGroup.get('passwordConfirmation')?.dirty
          "
        >
          Passwords must match
        </mat-error>
        <mat-error *ngIf="stateService.serverValidationErrors$ | async as errors">
          {{ errors['passwordConfirmation'] }}
        </mat-error>
      </div>
    </div>

    <div class="footer-actions">
      <app-button
        [theme]="'alternate'"
        tid="update-password-cancel-button"
        (click)="cancel()"
      >
        Cancel
      </app-button>
      <app-button
        [theme]="'primary-action'"
        tid="update-password-submit-button"
        [disabled]="!formGroup.valid"
        (click)="onSubmit()"
      >
        Update Password
      </app-button>
    </div>
  </form>
</app-auth-layout> 